'use client';
import CallToActionButtonContent from '@/components/landingPage/CallToActionButtonContent';
import clsx from 'clsx';

interface StickyCTAButtonProps {
  buttonText?: string;
  isVisible?: boolean;
}

const StickyCTAButton = ({ buttonText, isVisible = true }: StickyCTAButtonProps) => {
  return (
    <div
      className={clsx(
        'sticky bottom-6 z-40 mb-4 pl-4 pr-4 full-width md:hidden !bg-transparent transition-opacity duration-300',
        isVisible ? 'opacity-100' : 'invisible opacity-0',
      )}
      data-testid="stickyCTAButton"
    >
      <CallToActionButtonContent className="button w-full" defaultText={buttonText} />
    </div>
  );
};

export default StickyCTAButton;
